/* =========================

  Pagenation

  動きは要検討

============================ */
import styled from "styled-components";
import {break_point_sp} from "../../../Styled/mixin";

// Retina用imgタグ
import ImageRetina from "../../../Components/Part/ImageRetina";

import {useSelector} from "react-redux";

/* -------------------------

  component

---------------------------- */
function Pagenation( props ) {
  const datas = useSelector((state)=>state.datas);
  const count = useSelector((state)=>state.count);

  return (
    <>
    <Styled className={`${(datas.length < count)?"isFadeOut":""}`}>

      <div className="p-pagenation">
        {/* <div className={`p-pagenation__icon p-pagenation__icon--${props.num}`}>
          <ImageRetina
            type={"png"}
            src_pc_1x={"/assets/img/top/p-pagenation/pagenation_list-icon01.png"}
            src_pc_2x={"/assets/img/top/p-pagenation/pagenation_list-icon01@2x.png"}
            src_sp_1x={`/assets/img/top/p-pagenation/sp/pagenation_list-icon01.png`}
            src_sp_2x={`/assets/img/top/p-pagenation/sp/pagenation_list-icon01@2x.png`}
            alt={""}
          />
        </div> */}

        <div className="p-pagenation__bg">
          <ImageRetina
            type={"png"}
            src_pc_1x={`/assets/img/top/p-pagenation/pagenation_list-img0${props.num}.png`}
            src_pc_2x={`/assets/img/top/p-pagenation/pagenation_list-img0${props.num}@2x.png`}
            src_sp_1x={`/assets/img/top/p-pagenation/sp/pagenation_list-img0${props.num}.png`}
            src_sp_2x={`/assets/img/top/p-pagenation/sp/pagenation_list-img0${props.num}@2x.png`}
            alt={""}
          />
        </div>
      </div>

    </Styled>
    </>
  );
}

export default Pagenation;

/* -------------------------

  styled

---------------------------- */
const Styled = styled.div`
  .p-pagenation {
    position: relative;
    width: 437px;
    margin: auto;
    padding: 30px 0 0 0;
    .p-pagenation__icon {
      position: absolute;
      bottom: 2.2em;
      width: 41px;
      height: 59px;
    }
    .p-pagenation__icon--1 {
      position: absolute;
      left: 0;
    }
    .p-pagenation__icon--2 {
      position: absolute;
      left: 23%;
    }
    .p-pagenation__icon--3 {
      position: absolute;
      left: 46%;
    }
    .p-pagenation__icon--4 {
      position: absolute;
      left: 69%;
    }
    .p-pagenation__icon--5 {
      position: absolute;
      left: 92%;
    }
    .p-pagenation__bg {
    }
  }

	@media ${break_point_sp} {
    .p-pagenation {
      width: 100%;
      padding: 30px 0 0 0;
      .p-pagenation__icon {
        position: absolute;
        bottom: 2.3em;
        width: calc(59 / 437 * 100%);
        height: auto;
      }
      .p-pagenation__icon--1 {
        position: absolute;
        left: 0;
      }
      .p-pagenation__icon--2 {
        position: absolute;
        left: 21%;
      }
      .p-pagenation__icon--3 {
        position: absolute;
        left: 43%;
      }
      .p-pagenation__icon--4 {
        position: absolute;
        left: 65%;
      }
      .p-pagenation__icon--5 {
        position: absolute;
        left: auto;
        right: 0;
      }
      .p-pagenation__bg {
      }
    }
	}
`;

